import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined, MobileOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { login, getUserInfo } from '../../api/auth';
import { setToken, setUserInfo } from '../../utils/auth';
import './index.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    console.log('========================================');
    console.log('🔐 开始登录流程');
    console.log('手机号:', values.phone);
    
    try {
      // 调用真实的登录接口
      console.log('📞 调用登录接口...');
      const result = await login(values);
      console.log('登录接口返回:', result);
      
      // 检查返回结果
      if (result.code === 200) {
        console.log('✅ 登录接口成功');
        
        // 保存 token（会自动记录时间）
        if (result.token) {
          console.log('💾 保存token:', result.token.substring(0, 20) + '...');
          setToken(result.token);
          console.log('✅ token已保存，lastRequestTime已记录');
        } else {
          console.warn('⚠️ 登录成功但未返回token');
        }
        
        // 获取用户信息
        try {
          console.log('📞 调用获取用户信息接口...');
          const userInfoResult = await getUserInfo();
          console.log('用户信息接口返回:', userInfoResult);
          
          if (userInfoResult.code === 200 && userInfoResult.data) {
            // 保存完整的用户信息（使用后端返回的 isAdmin 字段）
            const userInfo = {
              ...userInfoResult.data,
              phone: values.phone
            };
            console.log('💾 保存用户信息:', userInfo);
            setUserInfo(userInfo);
            
            // 根据 isAdmin 显示不同的欢迎信息
            const welcomeMsg = userInfoResult.data.isAdmin ? '欢迎，管理员！' : '登录成功';
            message.success(welcomeMsg);
            console.log('✅ 用户信息已保存，isAdmin:', userInfoResult.data.isAdmin);
          }
        } catch (error) {
          console.error('❌ 获取用户信息失败:', error);
          // 即使获取用户信息失败，也保存基本信息
          const userInfo = {
            phone: values.phone
          };
          setUserInfo(userInfo);
          console.log('⚠️ 降级保存用户信息（无isAdmin）:', userInfo);
          message.success('登录成功');
        }
        
        console.log('🚀 跳转到房源管理页面');
        console.log('========================================');
        navigate('/apartments');
      } else {
        // 业务错误
        console.log('❌ 登录失败:', result.msg || result.message);
        console.log('========================================');
        message.error(result.msg || result.message || '登录失败');
      }
    } catch (error) {
      console.error('❌ 登录异常:', error);
      console.log('========================================');
      // 显示错误信息
      const errorMessage = error.message || '登录失败，请检查手机号和密码';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card" title="51APT公寓管理系统">
        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="phone"
            rules={[
              { required: true, message: '请输入手机号' },
              { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
            ]}
          >
            <Input 
              prefix={<MobileOutlined />} 
              placeholder="手机号" 
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6位' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              block 
              loading={loading}
            >
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;


